module.exports = __webpack_public_path__ + "static/media/logo.b4eca7ab.svg";